import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { IUpdateLocale, LocalizationContents } from "../../../LocalizationContents";
import { GameModel } from "../../../Models/GameModel";
export interface IRoundRawControllerOptions {
    scoreA: number,
    scoreB: number
}

export class RoundRawController extends AnimationBaseController implements IUpdateLocale {
    $model: GameModel

    public constructor(@Inject private _options: IRoundRawControllerOptions) {
        super("RoundRawController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {

        };
    }

    protected onInitialize(): void {
        this.updateLocale();
        this.setTextByQuery("blue_line.score_a_text", this._options.scoreA.toString());
        this.setTextByQuery("blue_line.score_b_text", this._options.scoreB.toString());

        if (this._options.scoreA >= this._options.scoreB) {
            this.gotoAndStopByQuery('blue_line.red_marker', 'on');
        } else {
            this.gotoAndStopByQuery('blue_line.red_marker', 'off');

        }

        if (this._options.scoreB >= this._options.scoreA) {
            this.gotoAndStopByQuery('blue_line.blue_marker', 'on');
        } else {
            this.gotoAndStopByQuery('blue_line.blue_marker', 'off');

        }
    }

    updateLocale() {
        this.setTextByQuery("blue_line.round_label_text", LocalizationContents.getText("tablo_round").toLocaleUpperCase());
    }
}